/** Determines whether the webapp is run in a production or development environment */
const ENV = {
  PRODUCTION: "PRODUCTION",
  DEVELOPMENT: "DEVELOPMENT",
  LOCAL: "LOCAL",
}

/** API URLs */
const API_URL = {
  PRODUCTION: "https://api.app.simpliworks.io",
  DEVELOPMENT: "https://api.dev.simpliworks.io",
  RAIDEN: "https://api.raiden.simpliworks.io",
  SCORPION: "https://api.scorpion.simpliworks.io",
  LOCAL: "http://localhost:8000",
}

const hostname = window.location.hostname

let CURRENT_ENV, CURRENT_API_URL
switch (hostname) {
  case "app.simpliworks.io":
    CURRENT_ENV = ENV.PRODUCTION
    CURRENT_API_URL = API_URL.PRODUCTION
    break
  case "dev.simpliworks.io":
  case "raiden.simpliworks.io":
  case "scorpion.simpliworks.io":
    CURRENT_ENV = ENV.DEVELOPMENT
    if (hostname === "raiden.simpliworks.io") CURRENT_API_URL = API_URL.RAIDEN
    else if (hostname === "scorpion.simpliworks.io")
      CURRENT_API_URL = API_URL.SCORPION
    else CURRENT_API_URL = API_URL.DEVELOPMENT
    break
  default:
    CURRENT_ENV = ENV.LOCAL
    CURRENT_API_URL = API_URL.LOCAL
}

/** LWA */
const LWA_CLIENT_ID =
  "amzn1.application-oa2-client.52885b7eb41d4e9e9d535ade8616a5af"

/** Seller Partner API */
const SPAPI_APP_ID = "amzn1.sp.solution.ab86d6e2-5dfc-4508-bff1-b293307026f6"

/** Stripe Production Keys */
const STRIPE_PK = {
  TEST: "pk_test_R4OHWSiGkOLSZFTPpIWkR4O500PGOAQPXu",
  LIVE: "pk_live_IxljfHgHVMyoJBiUVkSaSltW00Kpf9G81w",
}

// const CURRENT_STRIPE_PK = "pk_live_IxljfHgHVMyoJBiUVkSaSltW00Kpf9G81w"
const CURRENT_STRIPE_PK =
  CURRENT_ENV === ENV.PRODUCTION ? STRIPE_PK.LIVE : STRIPE_PK.TEST
//CURRENT_ENV === ENV.PRODUCTION ? STRIPE_PK.LIVE : STRIPE_PK.TEST

/** Customer Support Email */
const CUSTOMER_SUPPORT_EMAIL = "developer@simpliworks.io"

/** Seller Marketplaces */
const COUNTRIES = ["USA", "Canada", "Mexico"]
const SetInnerHtmlWithClassReplacement = (htmlContent) => {
  // Create a temporary div element
  const tempDiv = document.createElement('div');
  // Set the inner HTML of the div
  tempDiv.innerHTML = htmlContent;

  // Find all elements with the class 'ql-align-right'
  const elements = tempDiv.getElementsByClassName('ql-align-right');
  const elementsCenter = tempDiv.getElementsByClassName('ql-align-center');
  const monospaceElements = tempDiv.getElementsByClassName('ql-font-monospace');
  const elementSansSerif = tempDiv.getElementsByClassName('ql-sans-serif');
  const elementSerif=tempDiv.getElementsByClassName('ql-serif');
  // Replace 'ql-align-right' with 'text-end'
  Array.from(elements).forEach(element => {
    element.classList.remove('ql-align-right');
    element.style.textAlign = 'right'; 

  });
  Array.from(elementsCenter).forEach(element => {
    element.classList.remove('ql-align-center');
    element.style.textAlign = 'center'; 

  });
  Array.from(elementSansSerif).forEach(element => {
    element.classList.remove('ql-font-serif');
    element.style.textAlign = 'sans-serif'; 
  });
  Array.from(elementSerif).forEach(element => {
    element.classList.remove('ql-serif');
    element.style.textAlign = 'serif'; 
  });
  Array.from(monospaceElements).forEach(element => {
    element.classList.remove('ql-font-monospace');
    element.style.fontFamily = 'monospace'; // Apply inline CSS for monospace font
  });

  return tempDiv.innerHTML;
};

const Editor = {}

Editor.modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['link','image'], // To Add Image and Video  ['link', 'image', 'video'],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    // ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
}
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "color",
  "background",
  "code-block",
  "script",
  "align",
  // "clean",
  'image', 
  // 'video', // 'image', 'video',  - To White list image and video
]

export {
  LWA_CLIENT_ID,
  SPAPI_APP_ID,
  CURRENT_STRIPE_PK,
  CURRENT_API_URL,
  CUSTOMER_SUPPORT_EMAIL,
  COUNTRIES,
  CURRENT_ENV,
  Editor,
  SetInnerHtmlWithClassReplacement
}
